import axios from 'axios';

export default {
  state: {
    // Keep track of empty query results on their own, since you can't set a
    // property of '' on the searchResultsByQuery object.
    emptyQueryNameOnlySearchResults: null,
    emptyQueryNameAndContentSearchResults: null,

    nameOnlySearchResultsByQuery: {},
    isFetchingNameOnlySearchResultsByQuery: {},
    nameAndContentSearchResultsByQuery: {},
    isFetchingNameAndContentSearchResultsByQuery: {},
  },

  getters: {
    getCachedSearchResults: (state) => (query) => {
      if (query === '') {
        if (state.emptyQueryNameAndContentSearchResults) {
          return state.emptyQueryNameAndContentSearchResults;
        } else if (state.emptyQueryNameOnlySearchResults) {
          return state.emptyQueryNameOnlySearchResults;
        }
      }
      if (state.nameAndContentSearchResultsByQuery[query]) {
        return state.nameAndContentSearchResultsByQuery[query];
      }
      if (state.nameOnlySearchResultsByQuery[query]) {
        return state.nameOnlySearchResultsByQuery[query];
      }
      return null;
    },
    nameAndContentSearchResultsAreCachedForQuery: (state) => (query) => {
      if (
        typeof state.nameAndContentSearchResultsByQuery[query] !== 'undefined'
      ) {
        return true;
      }
      return false;
    },
    isFetchingNameOnlySearchResultsByQuery: (state) => (query) => {
      return state.isFetchingNameOnlySearchResultsByQuery[query];
    },
    isFetchingNameAndContentSearchResultsByQuery: (state) => (query) => {
      return state.isFetchingNameAndContentSearchResultsByQuery[query];
    },
  },
  actions: {
    async fetchAndCacheNameOnlySearchResults(
      context,
      { query = '', queryUuid = crypto.randomUUID() },
    ) {
      context.state['isFetchingNameOnlySearchResultsByQuery'][query] = true;

      try {
        const response = await axios.get('/api/v2/search', {
          params: {
            search_document_contents: false,
            query,
            query_uuid: queryUuid,
          },
        });

        if (query === '') {
          context.state['emptyQueryNameOnlySearchResults'] = response.data;
        } else {
          context.state['nameOnlySearchResultsByQuery'][query] = response.data;
        }
        return response.data;
      } finally {
        context.state['isFetchingNameOnlySearchResultsByQuery'][query] = false;
      }
    },
    async fetchAndCacheFullContentSearchResults(
      context,
      { query = '', queryUuid = crypto.randomUUID() },
    ) {
      context.state['isFetchingNameAndContentSearchResultsByQuery'][query] =
        true;

      try {
        const response = await axios.get('/api/v2/search', {
          params: {
            search_document_contents: true,
            query,
            query_uuid: queryUuid,
          },
        });

        if (query === '') {
          context.state['emptyQueryNameAndContentSearchResults'] =
            response.data;
        } else {
          context.state['nameAndContentSearchResultsByQuery'][query] =
            response.data;
        }
        return response.data;
      } finally {
        context.state['isFetchingNameAndContentSearchResultsByQuery'][query] =
          false;
      }
    },
  },
};
